export const setUserAction = (user) => {
  return {
    type: "SET_USER",
    payload: user,
  };
};
